import { Component, Input } from '@angular/core';

import { isVenda, isBonificacao, isAmostra, isConsignacao, isRemessa, isSimulacao, isOrcamento, isTipoVendaOutro } from '../config-pedido-tipo-venda-indicador';

@Component({
    selector: 'sgt-config-pedido-tipo-venda-badge',
    templateUrl: './config-pedido-tipo-venda-badge.component.html',
    styleUrls: ['./config-pedido-tipo-venda-badge.component.less']
})
export class ConfigPedidoTipoVendaBadgeComponent {
    /** Tipo de Venda */
    @Input() tipoVenda: number;
    /** Se o badge deve exibir o tipo de forma abreviada */
    @Input() isAbreviacao = false;
    /** Status da Amostra */
    @Input() statusAmostra: number;

    /** Verifica se é o tipo de venda Venda */
    isVenda(): boolean {
        return isVenda(this.tipoVenda);
    }

    /** Verifica se é o tipo de venda Bonificação */
    isBonificacao(): boolean {
        return isBonificacao(this.tipoVenda);
    }

    /** Verifica se é o tipo de venda Amostra */
    isAmostra(): boolean {
        return isAmostra(this.tipoVenda);
    }

    /** Verifica se é o tipo de venda Consignação */
    isConsignacao(): boolean {
        return isConsignacao(this.tipoVenda);
    }

    /** Verifica se é o tipo de venda Remessa */
    isRemessa(): boolean {
        return isRemessa(this.tipoVenda);
    }

    /** Verifica se é o tipo de venda Simulação */
    isSimulacao(): boolean {
        return isSimulacao(this.tipoVenda);
    }

    /** Verifica se é o tipo de venda Orçamento */
    isOrcamento(): boolean {
        return isOrcamento(this.tipoVenda);
    }

    /** Verifica se é o tipo de venda Outro */
    isOutro(): boolean {
        return isTipoVendaOutro(this.tipoVenda);
    }
}
